import {
    Filter,
    FilterOperation,
    StringValueFilterModel,
    ValueFilter,
} from '@ag-table-lib/filter.model'
import {
    CustomFilterParams,
    DefaultCustomFilterComponent,
} from '@ag-table-lib/filters/default-custom-filter.component'
import { Component } from '@angular/core'
import { deepEqualAny } from '@util-lib/deepEqualAny'
import { AgPromise, IDoesFilterPassParams } from 'ag-grid-community'
import { BehaviorSubject } from 'rxjs'

@Component({
    selector: 'app-text-filter',
    templateUrl: './text-filter.component.html',
    styles: [],
})
export class TextFilterComponent<U> extends DefaultCustomFilterComponent<
    string,
    U
> {
    readonly filterValue$ = new BehaviorSubject('')

    override agInit(params: CustomFilterParams) {
        super.agInit(params)

        this.subscription.add(
            this.filterValue$.subscribe((value) => {
                this.applyButtonDisabled =
                    !value ||
                    deepEqualAny(this.lastModel$.value, this.getModel())
            })
        )

        this.subscription.add(
            this.lastModel$.subscribe((model) => {
                const value = model?.[0] as ValueFilter<U> | null
                this.resetButtonDisabled = !value
            })
        )
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        // only continue in clientSide mode, otherwise let the backend handle it
        if (this.params?.rowModel.getType() !== 'clientSide') {
            return false
        }
        // get the value to be checked
        const nodeValue = super.getValue(params)

        // get search string
        const filterValue = this.getModel()?.pop() as ValueFilter<U> | null
        if (!filterValue?.value) {
            return true
        }
        // split search string into words
        const regExps = filterValue.value
            .split(' ')
            .filter((word) => word?.length)
            .map((word) => new RegExp(word, 'i'))
        // check if any value matches any search words
        return (
            !!nodeValue &&
            regExps.reduce<boolean>(
                (result, regExp) => result || regExp.test(nodeValue),
                false
            )
        )
    }

    getModel(): Partial<Filter<U>>[] | null {
        const filterValue = this.filterValue$.value
        if (filterValue === '') return null
        else
            return [
                {
                    op: FilterOperation.LIKE,
                    value: this.params?.inputSanitizer
                        ? this.params?.inputSanitizer(filterValue)
                        : filterValue,
                },
            ]
    }

    setModel(model: StringValueFilterModel[] | null): void | AgPromise<void> {
        this.filterValue$.next(model?.[0]?.value ?? '')
    }
}
